// extracted by mini-css-extract-plugin
export default {"pills":"TopicPills-module__pills--MpaO9","child":"TopicPills-module__child--x81DU","more":"TopicPills-module__more--mqyQ-"};